import { z } from 'zod';
import { id } from '../../../common/atomic/id';
import { pageableSchema } from '../../pageable/response';
import { attachmentSchema } from '../../../common/basic/attachment';

export const applicantAttachmentSchema = z
  .object({
    appId: id,
  })
  .merge(attachmentSchema);

const applicantAttachmentsSchema = z
  .object({
    content: z.array(applicantAttachmentSchema),
  })
  .merge(pageableSchema);

export type ApplicantAttachment = z.infer<typeof applicantAttachmentSchema>;
export type ApplicantAttachments = z.infer<typeof applicantAttachmentsSchema>;
